module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "notifications-template"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Tryout',
          to: {
            path: '/tryouts'
          }
        },
        {
          text: 'Laporan Tryout'
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('div', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "10"
    }
  }, [_c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("Laporan Tryout")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "mb-10 mt-2"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('v-card', {
    staticClass: "mt-5",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pa-5"
  }, [_c('div', {
    staticClass: "grey--text"
  }, [_vm._v("Total Semua Problem")]), _vm._v(" "), _c('div', {
    staticClass: "font-weight-700 black--text mt-2",
    staticStyle: {
      "font-size": "24px"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.total_problem) + "\n                            "), _c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Laporan")])])])], 1)], 1), _vm._v(" "), _vm._l((_vm.problem), function(data, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "3"
      }
    }, [_c('v-card', {
      staticClass: "mt-5",
      attrs: {
        "flat": ""
      }
    }, [_c('v-card-text', {
      staticClass: "pa-5"
    }, [_c('div', {
      staticClass: "grey--text"
    }, [_vm._v("\n                            " + _vm._s(data.problem_name) + "\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "font-weight-700 black--text mt-2",
      staticStyle: {
        "font-size": "24px"
      }
    }, [_vm._v("\n                            " + _vm._s(data.total_report) + "\n                            "), _c('span', {
      staticClass: "font-weight-400",
      staticStyle: {
        "font-size": "14px"
      }
    }, [_vm._v("\n                                Laporan\n                            ")])])])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-card', [_c('v-card-title', [_vm._v(" Laporan Tryout ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('app-datatable', {
    attrs: {
      "items": _vm.data,
      "headers": _vm.headers,
      "has-action": false,
      "has-export": true,
      "has-duplicate": true,
      "has-custom-pagination": true,
      "has-custom-search": true,
      "custom-pagination-current-page": _vm.pagination.currentPage,
      "custom-pagination-per-page": _vm.pagination.perPage,
      "custom-pagination-total-pages": _vm.total,
      "custom-pagination-sort-mode": _vm.pagination.sortMode
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "exportClicked": function($event) {
        return _vm.exportTryout()
      },
      "changePage": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {currentPage: $event})
      },
      "changeSortMode": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {sortMode: $event})
      },
      "doSearch": function($event) {
        _vm.search = $event;
        _vm.fetchData();
      }
    }
  })], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d5b9c8f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/tryout_report/components/TryoutReport.vue
// module id = 2129
// module chunks = 1